import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-project-cards',
  templateUrl: './project-cards.component.html',
  styleUrls: ['./project-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectCardsComponent implements OnInit {
  @Input() projectCards: any[] = [];
  @Input() projectDefaultCategories: any[] = [];
  @Input() set filterByIndicator(value: any) {
    this.selectedIndicator = value;
  };
  @Input() set sortByFilter(value: any) {
      this.selectedRadioButton = value ? this.radioButtons.find((btn: any) => btn.value === value) : this.radioButtons[1];
  };
  @Input() quickActionData!: any;

  @Output() sortByChange = new EventEmitter<any>();
  @Output() indicatorSortEvent = new EventEmitter<any>();
  @Output() loadQuickActionMenuData = new EventEmitter<any>();
  @Output() emitPauseOrResumeProject = new EventEmitter<any>();
  @Output() emitGoToDashboard = new EventEmitter<any>();


  selectedRadioButton: any;
  selectedIndicator: any;
  selectedProjectCard: any | null = null;
  selectedTriggerEl: any | null;
  cardPositions: any = {
    middleScroll: false,
    shouldOpenLeft: false,
    bottomScroll: false
  }

  baseUrl!: string;

  radioButtons: any[] = [
    {label: this.translate.instant('team_overview_high'),slug: 'highest', id: 'radio1', value: 'DESC'},
    {label: this.translate.instant('team_overview_low'),slug: 'lowest', id: 'radio2', value: 'ASC'}];

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.baseUrl = environment.baseUrl;
  }

  setFilterByScore() {
    this.sortByChange.emit(this.selectedRadioButton?.value);
  }

  changeIndicator(indicator: any) {
    this.indicatorSortEvent.emit(indicator);
  }

  openQuickActionsMenu(cardProject: any, triggerEl: HTMLElement) {
    this.selectedProjectCard = cardProject;
    this.showSidePanel(triggerEl);
    this.loadQuickActionMenuData.emit(cardProject.project.uuid);
  }

  showSidePanel(triggerEl: HTMLElement) {
    this.cardPositions.middleScroll = false;
    this.cardPositions.bottomScroll = false;

    const rect = triggerEl.getBoundingClientRect();
    const panelWidth = 300;
    const padding = 52;
    const spaceRight = window.innerWidth - rect.right;

    this.cardPositions.shouldOpenLeft = spaceRight < (panelWidth + padding);
    this.cdr.detectChanges();
    requestAnimationFrame(() => {
        this.adjustPosition(triggerEl);
    });
  }

  adjustPosition(triggerEl: HTMLElement) {
    const panel = triggerEl.querySelector('.pto-card') as HTMLElement;
    if (!panel) return;

    const triggerRect = triggerEl.getBoundingClientRect();
    const panelRect = panel.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const panelHeight = panelRect.height;
    const spaceAbove = triggerRect.top;
    const spaceBelow = viewportHeight - triggerRect.bottom;
    
    if (spaceAbove >= panelHeight / 2 && spaceBelow >= panelHeight / 2) {
      this.cardPositions.middleScroll = true;
    } else if (spaceBelow < panelHeight / 2 && spaceAbove >= panelHeight) {
      this.cardPositions.bottomScroll = true;
    }
  }

  pauseOrResumeProject(data: any) {
    this.emitPauseOrResumeProject.emit(data);
  }

  closeQuickActionsMenu() {
    this.selectedProjectCard = null;
  }

  goToProjectDashboard() {
    this.emitGoToDashboard.emit(this.selectedProjectCard);
  }

}
